/* eslint-disable react/prop-types */
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import * as React from "react";
import { useState } from "react";
import GeneralInfo from "./GeneralInfo";
import Opportunities from "./Opportunities";
import Transactions from "./Transactions";

export default function MoreInfoTabs({ singleGhollak }) {
  const [tab, setTab] = useState("1");
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };
  return (
    <TabContext value={tab}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList onChange={handleChange}>
          <Tab label="اطلاعات کلی" value="1" />
          <Tab label="فرصت ها" value="2" />
          <Tab label="تراکنش ها" value="3" />
        </TabList>
      </Box>
      <TabPanel value="1" sx={{ fontSize: 16 }}>
        <GeneralInfo singleGhollak={singleGhollak} />
      </TabPanel>
      <TabPanel value="2">
        <Opportunities singleGhollak={singleGhollak}/>
      </TabPanel>
      <TabPanel value="3">
        <Transactions singleGhollak={singleGhollak} />
      </TabPanel>
    </TabContext>
  );
}
